<template lang="pug">
  .course-constructor
    template(v-if="!$loader.isLoading")
      v-btn(
        v-if="$user.isAuthenticated"
        :to="{ name: 'CourseList' }"
        color="primary"
        depressed rounded
        style="position: absolute; top: 28px; right: 20px; z-index: 4"
      )
        v-icon(left) mdi-chevron-left
        | Назад
      course-constructor(
        v-if="!readonly || (readonly && course.constructor.length)"
        :readonly="readonly"
        :course="course.item"
        :constructor-data="course.constructor "
        :method="adapter"
      )
        template(#title-slot)
          .mb-4.d-flex.align-center(
            v-if="!course.item.isQualification && course.item.type_activity.name"
          )
            div
              strong {{ course.item.type_activity.name }}
              .caption.grey--text Направленность
            v-img(
              :src="course.item.type_activity.img_transparent"
              height="100"
              max-width="150"
            )
          .mb-4
            template(v-if="course.item.price")
              h2 {{ course.item.price | humanumber }} руб.
              .caption.opacity Стоимость освоения курса
            template(v-else)
              strong Бесплатный курс
          v-btn(
            v-if="course.item.prior_records && course.item.prior_records.length"
            color="white"
            large
            depressed
            light
            @click="enrollShowDialog"
          )
            v-icon mdi-rocket-launch
            span.ml-2 Записаться на курс
          v-chip(v-else light) Запись скоро откроется..
        template(#footer)
          v-footer(
            ref="section-footer"
            v-if="course.item.organization"
            padless
          )
            v-card(
              flat
              tile
              color="secondary"
              width="100%"
            )
              v-card-text
                v-row
                  v-col(cols="12" sm="5" md="4" offset="1")
                    v-list.transparent
                      v-list-item
                        v-list-item-icon.mr-4: v-icon(color="white") mdi-briefcase-variant
                        v-list-item-content.white--text.text-body-1
                          | ООО  "Персонифицированное Дистанционное Образование"
                          .text-body-2 7610141220/761001001
                      v-list-item
                        v-list-item-icon.mr-4: v-icon(color="white") mdi-map
                        v-list-item-content.white--text.text-body-1
                          | Ярославская область, Пошехонский р-н,
                          |   г Пошехонье, Красноармейская ул, д. 9б, 13
                      v-list-item(
                        href="tel:+79022250804"
                      )
                        v-list-item-icon.mr-4: v-icon(color="white") mdi-phone
                        v-list-item-content.white--text.text-body-1: strong +7 902 225-08-04
                      v-list-item(
                        href="mailto:kpk@pfdo.ru"
                      )
                        v-list-item-icon.mr-4: v-icon(color="white") mdi-email
                        v-list-item-content.white--text.text-body-1: strong kpk@pfdo.ru

                  v-col(cols="12" sm="5" md="4" offset-md="2" offset-sm="0" offset="1")
                    v-list.transparent
                      v-list-item(
                        target="_blank"
                        @click="OpenPaymentDetailsModal"
                      )
                        v-list-item-icon.mr-4: v-icon(color="white") mdi-domain
                        v-list-item-content.white--text.text-body-1 {{ organization.full_name }}
                      v-list-item(
                        v-for="item in course.agreements"
                        :key="item.id"
                        target="_blank"
                        :to="{ name: 'ConstructorDocumentView', params: { id: item.id }}"
                      )
                        v-list-item-icon.mr-4: v-icon(color="white") mdi-file-document
                        v-list-item-content.white--text.text-body-1: strong {{ item.title }}
      C-section-title(
        v-else
        :course="course.item"
        readonly
        :value=`{
          title: course.item.title,
          description: course.item.description,
          shadow_level: 90,
        }`
      ).height-100vh
        template(#title-slot)
          .mb-4.d-flex.align-center(
            v-if="!course.item.isQualification && course.item.type_activity.name"
          )
            div
              strong {{ course.item.type_activity.name }}
              .caption.grey--text Направленность
            v-img(
              :src="course.item.type_activity.img_transparent"
              height="100"
              max-width="150"
            )
          .mb-4
            template(v-if="course.item.price")
              h2 {{ course.item.price | humanumber }} руб.
              .caption.opacity Стоимость освоения курса
            template(v-else)
              strong Бесплатный курс
          v-btn(
            v-if="course.item.prior_records && course.item.prior_records.length"
            color="white"
            large
            depressed
            light
            @click="enrollShowDialog"
          )
            v-icon mdi-rocket-launch
            span.ml-2 Записаться на курс
          v-chip(v-else light) Запись скоро откроется..

</template>

<script>
import CourseConstructor from '@/components/Constructor/index.vue';
import CSectionTitle from '@/components/Constructor/CSectionTitle.vue';
import CreateContractModal from '@/components/Enrollment/CreateContractModal.vue';
import EnrollmentList from '@/modules/Enrollments/components/EnrollmentsList.vue';
import ToSignIn from '@/modules/CourseManagement/components/ToSignIn.vue';
import OrganizationPaymentDetails from '../components/OrganizationPaymentDetails.vue';

export default {
  components: {
    CourseConstructor,
    CSectionTitle,
  },
  data: () => ({
    course: {
      item: null,
      constructor: null,
      loading: true,
      agreements: [],
    },
  }),
  computed: {

    readonly() {
      return this.$route.meta.readonly;
    },
    organization() {
      return this.course.item.organization;
    },
  },
  async created() {
    this.$loader.start();
    await Promise.all([
      this.fetchCourse(),
      this.fetchConstructor(),
    ]);
    this.$loader.stop();
  },
  methods: {
    adapter(payload, background) {
      if (background && background.filename) {
        this.course.item.update({
          data: {
            image: {
              name: background.filename,
            },
          },
        });
      }
      return this.$api.courses.constructorSave(this.course.item.id, payload);
    },
    OpenPaymentDetailsModal() {
      this.$modals.show('generic-controller', {
        component: OrganizationPaymentDetails,
        title: 'Платёжные реквизиты',
        dialogProps: { maxWidth: 800 },
        componentProps: {
          organizationId: this.organization.id,
        },
      });
    },
    async fetchCourse() {
      const { item } = await this.$api.courses.show(this.$route.params.id, {
        expand: 'prior_records,organization',
      });
      this.course.item = item;
      this.course.item.fetchUnits(this.readonly);
      this.fetchAgreements();
    },
    async fetchAgreements() {
      const resp = await this.$api.contracts.getAgreements({
        'search[organization_id]': this.course.item.organization.id,
        'search[is_active]': true,
      });
      this.course.agreements = resp.data.data;
    },
    async fetchConstructor() {
      const resp = await this.$api.courses.constructorGet(this.$route.params.id, {
        expand: 'cards',
      });
      this.course.constructor = resp.data.data;
    },
    enrollShowDialog() {
      const { course } = this;
      const component = this.$user.isAuthenticated ? EnrollmentList : ToSignIn;
      const props = this.$user.isAuthenticated ? {
        enrollments: course.item.prior_records,
        'click:enrollment': (enrollment) => {
          const { isOrganization, isOperator, isDepartment } = this.$user;
          if (!(isOrganization || isOperator || isDepartment)) {
            this.enrollConfirmDialog(enrollment);
          } else {
            this.$router.push({
              name: 'CourseRegistrationStaff',
              params: {
                courseId: course.item.id,
                enrollmentId: enrollment.id,
              },
            });
            this.$modals.close();
          }
        },
      } : {};

      this.$modals.show('generic-controller', {
        title: this.$user.isAuthenticated ? 'Выберите набор' : 'Для записи на курс необходима авторизация',
        message: this.$user.isAuthenticated ? 'Список активных наборов курса:' : '',
        component,
        'component-props': props,
      });
    },
    async enrollConfirmDialog(enrollment) {
      if (!this.$user.isAuthenticated) {
        this.$router.push({ name: 'SignIn', query: { redirect: this.$route.path } });
        return;
      }
      const method = async () => {
        await this.$api.enrollments.enrollToCourse(enrollment.id);
        this.$router.push({
          name: 'EducationCourseUnitList',
          params: { courseId: this.course.item.id },
        });
        this.$modals.closeAll();
        this.$toasted.success('Вы записались на курс', { duration: 2000 });
      };
      const modalType = this.course.item.price ? 'generic-controller' : 'confirm-controller';

      const typicalParams = {
        'search[course_id]': this.course.item.id,
        'search[type]': 1,
      };

      this.$modals.show(modalType, {
        title: 'Запись на курс',
        message: this.course.item.price ? '' : 'Вы действительно хотите записаться на курс?',
        component: !this.course.item.price ? '' : CreateContractModal,
        dialogProps: {
          width: 1000,
        },
        componentProps: {
          organizationId: this.course.item.organization.id,
          noStep: true,
          enrollmentId: enrollment.id,
          params: typicalParams,
          successCallback: (id) => {
            this.$router.push({
              name: 'ContractView',
              params: { id },
              query: { courseId: this.course.item.id, payment: true },
            });
            this.$modals.closeAll();
            this.$toasted.success('Контракт создан', { duration: 2000 });
          },
        },
        method,
      });
    },
  },
};
</script>
